import { err, ok } from 'neverthrow'
import { AssertionStatus, RDiagnosisReviewItem } from '../../../formmodel/DiagnosisReview'
import { getConceptStatusValue } from '../../../concept/getConceptStatus'
import { evaluatorErrorWithNode } from '../../scriptevaluator/EvaluatorError'
import { functionNodeTypes, HelperFunction } from '../FunctionTypes'
import z from 'zod'

export const IsComorbidFunction: HelperFunction = {
	tokenName: 'IS_COMORBID',
	nodeType: functionNodeTypes.IsComorbid,
	evaluate(node, evaluateExpr, context) {
		if (node.arguments.length !== 1) {
			return err(evaluatorErrorWithNode('Is Comorbid function expects exactly one argument', node))
		}
		const result = evaluateExpr(node.arguments[0]) 
		if (result.isErr()) return err(result.error)
		if (typeof result.value !== 'string') {
			return err(evaluatorErrorWithNode('IS_COMORBID expects a concept ID string argument', node))
		}
		const statusValue = getConceptStatusValue(context.getStatus(result.value))
		const rParsedModels = z.array(RDiagnosisReviewItem).safeParse(statusValue)

		if(!rParsedModels.success) {
			return err(evaluatorErrorWithNode('IS_COMORBID expects the concept status value to be an array of diagnosis review items', node))
		}

		for (const reviewItem of rParsedModels.data) {
			if (reviewItem.status !== AssertionStatus.Asserted) {
				continue
			}

			// if any dx has comorbidity status, then comorbid = true (per ticket 1854)
			if (reviewItem.icdComorbidityStatus) {
				return ok(true)
			}
		}
		return ok(false)
	}
}